import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantService } from '../services/tenant.service';

const ADMIN_PATH_PREFIXES = ['/api/admin'];

function isAdminUrl(url: string): boolean {
  return ADMIN_PATH_PREFIXES.some(prefix => url.includes(prefix));
}

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  if (isAdminUrl(req.url)) {
    return next(req);
  }

  const tenantService = inject(TenantService);
  const tenantId = tenantService.activeTenantId();

  if (!tenantId) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        'X-Domain-App': tenantId,
      },
    })
  );
};
